export default __webpack_public_path__ + "static/4-d1dcd3cbeada8df608181b9c191c1dd3.jpg";